/**
 * Кнопка поддержки — всегда в правом нижнем углу, открывает наш телеграм-бот.
 *
 * Поднята над подвалом: в правом нижнем углу уже стоит ссылка «Чат с
 * поддержкой», и на первом заходе кнопка её накрыла.
 *
 * Заменила виджет Carrot Quest. Причина не в виджете как таковом: пока окон
 * поддержки два (чат на сайте и бот в телеграме), сообщения теряются между
 * ними — человек пишет в одно, отвечают в другом. Оставляем одно окно, и это
 * бот, потому что он же обслуживает почту и мини-апп.
 */

const SUPPORT_BOT_URL = 'https://t.me/ps24supportbot'

export function SupportButton() {
  return (
    <a
      href={SUPPORT_BOT_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Написать в поддержку"
      title="Написать в поддержку"
      data-testid="support-button"
      className="fixed bottom-16 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-transform duration-150 hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
      style={{ backgroundColor: '#229ED9' }}
    >
      {/* Значок телеграма: рисуем сами, чтобы не тянуть внешний файл —
          у страницы строгая политика источников. */}
      <svg
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M21.7 3.3 2.8 10.6c-1.1.4-1.1 1.1-.2 1.4l4.8 1.5 1.8 5.6c.2.6.4.8 1 .8.5 0 .7-.2 1-.5l2.3-2.2 4.8 3.5c.9.5 1.5.2 1.7-.8l3.1-14.6c.3-1.3-.5-1.9-1.4-1.5Z"
          fill="#ffffff"
        />
        <path d="m9.2 13.9.3 4.1 2-3.6 5.9-5.3-8.2 4.8Z" fill="#d2e5f1" />
      </svg>
    </a>
  )
}
